export const conceptoGastoAdapter = (rawData) => {
  const { data } = rawData;
  if (data?.length > 0) {
    const rows = data?.map((item) => {
      const {
        ID,
        DESCRIPCION,
      } = item;

      return {
        id: ID ?? null ,
        descripcion: DESCRIPCION ?? null
      };
    });
    return { rows: rows };
  }
};
